import { useRef, useEffect } from "react";
import VListItem from "Components/Molecules/M_VViewer/VListItem";

//Componente que representa la Lista de eventos
export const VListEvents = (
  { volcanoItems, selectVolcano, volcanoSelected }
) => {

  const containerRef = useRef();

  const selectedRef = useRef(0);
  const listRef = useRef();

  const unselectItem = () =>{
   document.getElementById( `item-${ selectedRef.current }` )?.classList.remove( "Active" );
  }

  const toggleItem = (id) => {
     return document.getElementById( `item-${ id }` ).classList.toggle( "Active" );
  }

   const scrollInto = ( id ) => {
      document.getElementById( `item-${ id }` ).scrollIntoView({ block: "center", behavior: "smooth" })
   }

  const handleClickVolcano = (id) => {
     if ( id !== selectedRef.current ){
        unselectItem();
        selectedRef.current = id;
     }
      toggleItem( id ) ? selectVolcano( volcanoItems[ id ] ) : selectVolcano( null )
  }


  useEffect(() => {
   containerRef.current = document.getElementById( 'events-container' );
   const resizeObserver = new ResizeObserver( (entries) => {
      if ( entries[0]?.contentBoxSize[0].inlineSize < 500 ){
         listRef.current?.classList.add( "sm" );
      } else {
         listRef.current?.classList.remove( "sm" );
      }
      
   } );

   resizeObserver.observe( containerRef.current );
   // eslint-disable-next-line react-hooks/exhaustive-deps
   },[]);

  useEffect(() => {
      const volcanoIndex = volcanoItems.findIndex( e => e.id === volcanoSelected?.id ) 
      if ( volcanoIndex >= 0 ){
         unselectItem();
         selectedRef.current = volcanoIndex;
         toggleItem( volcanoIndex );
         scrollInto( volcanoIndex )
      }
   // eslint-disable-next-line react-hooks/exhaustive-deps
   },[ volcanoSelected ]);

  return (
    <div className="ListContainer" ref={ listRef }>
      {
         volcanoItems.map(( e, index ) => (
            <VListItem 
               key={ e.id }
               id={ e.id }
               index={ index }
               volcano={ e?.properties }
               onSelectItem={ handleClickVolcano }
               animateImg
            />
         ))
      }
    </div>
  )
}